import { render, staticRenderFns } from "./KeynoteIcon.vue?vue&type=template&id=5c579146"
import script from "./KeynoteIcon.vue?vue&type=script&lang=js"
export * from "./KeynoteIcon.vue?vue&type=script&lang=js"
import style0 from "./KeynoteIcon.vue?vue&type=style&index=0&id=5c579146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports